import { render, staticRenderFns } from "./OrderTrHistory.vue?vue&type=template&id=3b995b8f"
import script from "./OrderTrHistory.vue?vue&type=script&lang=js"
export * from "./OrderTrHistory.vue?vue&type=script&lang=js"
import style0 from "../../../sass/partials/sidebar-submenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports